import chatService from '@app/service/chatService';
import { getPeerChatCheck } from '@app/service/chatReadService';
import manageService from '@app/service/manageService';
import { isValidReservationId } from '@app/service/reservationIdGuard';
import { subscribeWithSelector } from 'zustand/middleware';
import { create } from 'zustand';
import { uniqueByKey } from '@utils/util';
// STORE
import deviceStore from './deviceStore';
import notificationStore from './notificationStore';
import MobileInquiryPageStore from '@app/pages/mobile/inquiry/MobileInquiryPageStore';
import MobileInquiryDtaileStore from '@app/pages/mobile/inquiry/MobileInquiryDtaileStore';
import { isLooseEqual } from '@app/utils/equality';


const initData = {
  chattingRoom: null,
  incomeChat: null,
  open: false,
};
const size = 30;
const mobileChatStore = create(
  subscribeWithSelector((set, get) => ({
    ...initData,
    resetRoom: async () => {
      const {
        appVersion,
        fcmPushToken,
        model,
        osType,
        osVersion,
        uuid,
      } = deviceStore.getState();
      const deviceInfoString = JSON.stringify({
        appVersion,
        fcmPushToken,
        model,
        osType,
        osVersion,
        uuid,
      });
      const messageString = JSON.stringify({
        callPage: `mobile - resetRoom()`,
        chattingRoom: get().chattingRoom,
      });

      const logData = { deviceInfo: deviceInfoString, message: messageString };
      const chattingRoom = get().chattingRoom;
      if (chattingRoom == null) return;
      let newChattingRoom = { ...chattingRoom };
      const params = { size, page: 0, sort: 'seq,DESC' };
      const messagesProm = await chatService.getMessages(
        chattingRoom?.id,
        params,
        logData,
      );
      if (
        chattingRoom == null ||
        chattingRoom?.id == null ||
        isLooseEqual(chattingRoom?.id, 'undefined') ||
        chattingRoom?.id == null ||
        isLooseEqual(chattingRoom?.id, 'null')
      )
        return;

      const messages = messagesProm.data.data.sort((a, b) => a.seq - b.seq);
      const totalPage = messagesProm.data.meta.totalPage;

      let checkSeq = null;
      if (messages && messages.length > 0) {
        const chatCheckProm = await getPeerChatCheck({
          bizId: chattingRoom.reservation?.travel?.id,
          businessType: 'TRAVEL',
          reservationId: chattingRoom.id,
        });
        const chatCheck = chatCheckProm.data.data;
        checkSeq = chatCheck?.checkLastSeq;
      }
      newChattingRoom.messages = messages;
      newChattingRoom.lastParams = params;
      newChattingRoom.totalPage = totalPage;
      newChattingRoom.checkSeq = checkSeq;

      set({ chattingRoom: newChattingRoom });
    },
    openChattingRoom: async (id) => {
      // 알림의 누락 ID는 예약·메시지 조회 전에 차단한다(기존 검사는 조회 뒤에 있었다).
      if (!isValidReservationId(id)) return;
      const {
        appVersion,
        fcmPushToken,
        model,
        osType,
        osVersion,
        uuid,
      } = deviceStore.getState();
      const deviceInfoString = JSON.stringify({
        appVersion,
        fcmPushToken,
        model,
        osType,
        osVersion,
        uuid,
      });
      const messageString = JSON.stringify({
        callPage: `mobile - openChattingRoom(${id})`,
      });
      const logData = { deviceInfo: deviceInfoString, message: messageString };

      try {
        const reservationProm = await manageService.getReservationInfo(id);
        const reservation = reservationProm.data.data;

        const params = { size, page: 0, sort: 'seq,DESC' };
        const messagesProm = await chatService.getMessages(id, params, logData);
        if (id == null || isLooseEqual(id, 'undefined') || id == null || isLooseEqual(id, 'null'))
          return;

        const messages = messagesProm.data.data.sort((a, b) => a.seq - b.seq);
        const totalPage = messagesProm.data.meta.totalPage;

        let checkSeq = null;
        if (messages && messages.length > 0) {
          const chatCheckProm = await getPeerChatCheck({
            bizId: reservation?.travel?.id,
            businessType: 'TRAVEL',
            reservationId: id,
          });
          const chatCheck = chatCheckProm.data.data;
          checkSeq = chatCheck?.checkLastSeq;
        }

        set({
          chattingRoom: {
            id,
            reservation: reservation,
            lastParams: params,
            totalPage: totalPage,
            checkSeq: checkSeq,
            messages: messages,
          },
          open: true,
        });

        if (messages && messages.length > 0) {
          const { checkNotificationGroup } = notificationStore?.getState();
          checkNotificationGroup(messages[messages.length - 1]?.seq, id);
          await chatService.messageCheck(
            id,
            messages[messages.length - 1]?.seq,
          );
        }
      } catch (e) {
        console.error('open ChattingRoom err : ', e);
      }
    },
    closeChattingRoom: () => {
      set({ open: false });
    },
    nextPage(id) {
      const chattingRoom = get().chattingRoom;
      if (isLooseEqual(chattingRoom.totalPage, 1)) {
        console.warn('마지막 페이지에 도달 했습니다.');
        return;
      }
      const lastParams = { ...chattingRoom.lastParams };
      lastParams.page = 0;
      lastParams.seq = chattingRoom.messages[0].seq;
      lastParams.seqType = 'BEFORE';
      chatService
        .getMessages(id, lastParams)
        .then((res) => {
          chattingRoom.messages = [
            ...res.data.data.sort((a, b) => a.seq - b.seq),
            ...chattingRoom.messages,
          ];
          chattingRoom.lastParams = lastParams;
          chattingRoom.totalPage = res.data.meta.totalPage;
          set({ chattingRoom: { ...chattingRoom } });
        })
        .catch((e) => {});
    },
    setIncomeChat: async (msg) => {
      console.log('setIncomeChat msg : ', msg);
      const newChattingRoom = { ...get().chattingRoom };
      if (isLooseEqual(newChattingRoom.id, msg.reservationId)) {
        newChattingRoom.messages = uniqueByKey(
          [...newChattingRoom.messages, msg],
          'seq',
        );
        // 현재 채팅방에 들어와 있으면 chattingRoom만 갱신
        set({ chattingRoom: newChattingRoom, incomeChat: msg });
        try {
          const open = get().open;
          if (open) {
            const { checkNotificationGroup } = notificationStore?.getState();
            checkNotificationGroup(msg.seq, msg.reservationId);
            await chatService.messageCheck(msg.reservationId, msg.seq);
          }
        } catch (e) {
          console.error('messsage check err : ', e);
        }
      } else {
        // 채팅방이 아니면 incomeChat만 갱신
        set({ incomeChat: msg });
      }
    },
    readMessage: (id, seq) => {
      const newChattingRoom = { ...get().chattingRoom };
      if (isLooseEqual(newChattingRoom.id, id)) newChattingRoom.checkSeq = seq;
      set({ chattingRoom: newChattingRoom });
    },
    resetStore: () => {
      set(initData);
    },
  })),
);

mobileChatStore.subscribe(
  (state) => state.incomeChat,
  (incomeChat) => {
    const inquiryList = MobileInquiryPageStore.getState().inquiryList;
    if (inquiryList?.length === 0) return;
    const chattingRoom = mobileChatStore.getState().chattingRoom;
    const open = mobileChatStore.getState().open;
    const isOpenRoom = isLooseEqual(chattingRoom?.id, incomeChat?.reservationId) && open;
    // 새로운 채팅 들어왔을 때 감지하여 객실 문의 리스트에 추가
    const findInquiry = inquiryList?.find(
      (data) => isLooseEqual(incomeChat?.reservationId, data.id),
    );
    if (!findInquiry) return;
    const newInquiryList = inquiryList.map((inquiry) => {
      if (isLooseEqual(findInquiry?.id, inquiry.id))
        return {
          ...inquiry,
          chatStatus: {
            reservationId: incomeChat?.reservationId,
            isCheck: isOpenRoom ? true : false,
          },
        };
      else return inquiry;
    });
    MobileInquiryPageStore.setState({ inquiryList: newInquiryList });

    // 새로운 채팅 들어왔을 때 감지하여 객실 문의 상세 페이지에서 채팅 뱃지 추가/삭제
    const inquiryDetail = MobileInquiryDtaileStore?.getState()?.inquiry;
    if (!isLooseEqual(incomeChat?.reservationId, inquiryDetail?.id)) return;
    const newInquiry = {
      ...inquiryDetail,
      chatStatus: {
        reservationId: incomeChat?.reservationId,
        isCheck: isOpenRoom ? true : false,
      },
    };
    MobileInquiryDtaileStore.setState({ inquiry: newInquiry });
  },
);

export default mobileChatStore;
